<script>
  import Home from './Home.svelte'
  import Page from './Page/App.svelte'
  import Header from './Header.svelte'
  import Footer from './Footer.svelte'

  let path = window.location.pathname
</script>

<main>
  <Header path={path} />
  {#if path == "/"}
    <Home />
  {:else}
    <Page path={path} />
  {/if}
  <Footer />
</main>

<style>
	main {
		margin: 0 auto;
	}
	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
